import { render, staticRenderFns } from "./ShiftTemplateCreateModal.vue?vue&type=template&id=4ba2dc24&"
import script from "./ShiftTemplateCreateModal.vue?vue&type=script&lang=js&"
export * from "./ShiftTemplateCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports